import React from 'react';
import { Icon } from '../../common/Icon';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { removeTimeEntryRow, updateIsLoading, updateIsReload, updateTimeEntriesAsync } from './timesheetSlice';
import { displayValueForTimeEntry } from '../../common/timesheetFunction';
import { ShowToast } from '../../common/Toastr';
import { FormatInvoiceDecimalNumberWithTwoDigitInteger } from '../../common/timeLiveFunction';

const TimesheetSectionThreeRow = (props: any) => {
    const dispatch = useAppDispatch();
    const { timeEntriesList, isLocked, accountEmployeeId, accountEmployeeTimeEntryPeriodId, isTimesheetPolicy, decimalFormat } = useAppSelector((state) => state.timesheet);
      const { showTimeOffInTimesheet,cultureInfoName,decimalPlaces } = useAppSelector((state) => state.globalState);
    const { rowId } = props;

    const getTimeFromDecimal = (value: number) => {
        if (value) {
            if (props.isDecimal) {
                return value.toFixed(2);
            }
            var minutes = Math.round(value * 60);
            if (minutes >= 60) {
                var hours = Math.floor((value * 60) / 60);
                var minutes = Math.round(minutes - (hours * 60));
                return (hours.toString().length == 1 ? "0" + hours : hours) + ":" + (minutes.toString().length == 1 ? "0" + minutes : minutes);
            }
            return "00:" + (minutes.toString().length == 1 ? "0" + minutes : minutes);
        } else {
            return (props.isDecimal ? 0.00 : "00:00");
        }
    }

    const handleOnClickIcon = (e: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "Removed entry will not be recovered", "Yes, Proceed")
            .then((result) => {
                if (result) {
                    const currentScrollPos = window.scrollY || document.documentElement.scrollTop;
                localStorage.setItem('delete_scroll_y', currentScrollPos.toString());
                localStorage.setItem('is_deleting_active', 'true');
                sessionStorage.removeItem('is_saving_active');
                    let TimeEntries = [] as any;
                    var objMasterEntry = timeEntriesList.find(x => x.rowId == rowId);
                    if (objMasterEntry) {
                        TimeEntries = objMasterEntry.timeEntries
                            .filter((x: any) => x.AccountEmployeeTimeEntryId !== null)
                            .map((x: any) => x.AccountEmployeeTimeEntryId);
                    }
                    if (TimeEntries.length > 0) {
                        const { AccountClientId, AccountProjectId, AccountProjectTaskId, AccountEmployeeTimeEntryApprovalProjectId, AccountWorkTypeId, AccountCostCenterId } = objMasterEntry;
                        const postObject = {
                            AccountEmployeeId: accountEmployeeId,
                            AccountClientId: AccountClientId ? AccountClientId : 0,
                            AccountProjectId: AccountProjectId ? AccountProjectId : 0,
                            AccountProjectTaskId: AccountProjectTaskId ? AccountProjectTaskId : 0,
                            ApprovalProjectId: AccountEmployeeTimeEntryApprovalProjectId,
                            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                            TimeEntries: TimeEntries,
                            IsDelete: true,
                            AccountWorkTypeId: AccountWorkTypeId,
                            AccountCostCenterId: AccountCostCenterId === null ? 0 : AccountCostCenterId
                        }
                        //dispatch(updateIsLoading(true));
                        dispatch(updateTimeEntriesAsync({ RowId: rowId, ...postObject }))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                ShowToast('Record Deleted successfully!', 'Deleted', 'success');
                                dispatch(updateIsReload(true));
                                //dispatch(updateIsReload(true));
                            })
                            .catch((rejectedValueOrSerializedError) => {
                            });
                    } else {
                        dispatch(removeTimeEntryRow(rowId));
                    }
                }
            })
            .catch((error) => {
                localStorage.removeItem('is_deleting_active');
            localStorage.removeItem('delete_scroll_y');
            });
    }

    return (
        <tr className={"timesheet-row"} style={{ position: "relative", backgroundColor: '#fafbfc', borderRightStyle: 'hidden' }}>
            <td>
                <span className={"line-Item-Total"}>{decimalFormat ? FormatInvoiceDecimalNumberWithTwoDigitInteger(cultureInfoName.toString(), timeEntriesList.find(x => x.rowId == rowId).Total, 2) : displayValueForTimeEntry(timeEntriesList.find(x => x.rowId == rowId).Total, isTimesheetPolicy, decimalFormat)}
                </span>
            </td>
            {!isLocked &&
                <td>
                    {/* <Icon iconName="XCircle" onClick={handleOnClickIcon} style={{ color: '#FF0000', cursor: 'pointer' }} /> */}
                    {!timeEntriesList.find(x => x.rowId == rowId).isTimeOff ?
                        <Icon iconName="X" className='fs-1' onClick={handleOnClickIcon} style={{ color: '#172b4d8a', cursor: 'pointer' }} /> :
                        timeEntriesList.find(x => x.rowId == rowId).AccountEmployeeTimeOffRequestId === null &&
                        <Icon iconName="X" className='fs-1' onClick={handleOnClickIcon} style={{ color: '#172b4d8a', cursor: 'pointer' }} />
                    }
                </td>
            }
        </tr>
    );
}

export default TimesheetSectionThreeRow